// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mNRKYUG1P6T_aM {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: jGBp0IVeobpkm3;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 80px;
  height: 16px;
  margin-top: var(--ds-space-200, 16px);
}
@keyframes jGBp0IVeobpkm3 {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .mNRKYUG1P6T_aM {
    animation: none;
  }
}
.vWHh7sWe_AFBAW {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: jGBp0IVeobpkm3;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 100%;
  height: 36px;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
}
@keyframes jGBp0IVeobpkm3 {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .vWHh7sWe_AFBAW {
    animation: none;
  }
}
`, ""]);
// Exports
export var skeletonHeader = `mNRKYUG1P6T_aM`;
export var shimmer = `jGBp0IVeobpkm3`;
export var skeletonRow = `vWHh7sWe_AFBAW`;
export default ___CSS_LOADER_EXPORT___;
